define(['jquery', 'app/global', 'app/tools', 'jquery.cookie'], function ($, global, tools) {
  // Cookie RODO V2

  // ech, po prstu stary serwis… jak użytkownik źle to zrobi
  var defaultTemplate = `<div class="cookie-rodo__text"><p>Aby świadczyć usługi na najwyższym poziomie, Internetowe serwisy informacyjne PKO Banku Polskiego
  wykorzystują pliki cookies zapisywane w pamięci przeglądarki. Szczegółowe informacje na temat celu ich
  używania oraz zmiany ustawień plików cookies w przeglądarce internetowej znajdują się w <a href="https://inteligo.pl/przydatne-informacje/bezpieczenstwo/polityka-prywatnosci/" target="_blank">Polityce
      prywatności</a>.</p><p>
  Dalsze korzystanie z serwisu bez zmiany ustawień dotyczących cookies w przeglądarce oznacza
  potwierdzenie zapoznania się z powyższymi informacjami i akceptację plików cookies.</p></div>`;

  return function () {
    var rodoCookie = 'inteligoCookieRodo',
      rodoPostponeCookie = 'inteligoPostponeCookieRodo',
      template,
      $popup,
      $acceptButton,
      $popupText,
      $remindButton;

    function cookieAction(deviceClassName) {
      template = tools.getTemplate(deviceClassName);
      global.cache.$body.prepend(template);

      $popup = global.cache.$body.find('.js-cookie-rodo');
      $popupText = $('.js-rodo-text');
      $acceptButton = $popup.find('.js-rodo-accept');
      $remindButton = $popup.find('.js-rodo-remind');

      if (!$popupText.length) {
        $('.js-rodo-wrapper').html(defaultTemplate);
      }

      $acceptButton.on('click', function (e) {
        e.preventDefault();

        $.cookie(rodoCookie, '1', {
          path: '/',
          expires: 365
        });

        $.removeCookie(rodoPostponeCookie, { path: '/' });

        $popup.remove();
      });

      $remindButton.on('click', function (e) {
        e.preventDefault();

        $.cookie(rodoPostponeCookie, '1', {
          path: '/',
          expires: 1 / 8
        });

        $popup.remove();
      });
    }

    if ($.cookie(rodoCookie) === undefined && $.cookie(rodoPostponeCookie) === undefined) {
      $templateCookieMobile = $('#template-cookie-mobile');
      $templateCookieDesktop = $('#template-cookie-desktop');

      if ($templateCookieMobile.length) {
        cookieAction('cookie-mobile');
      } else if ($templateCookieDesktop.length) {
        cookieAction('cookie-desktop');
      }
    }
  };
});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/shared/cookie-policy.js